define('lq/events/actions/redirect',[
    'lq',
    './eventAction',
    'lq/util',
    'lq/validatorGateway',
    'uuid'
], function (lq, EventAction, util, validatorGateway, uuid) {
    'use strict';

    function Redirect(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Redirect, EventAction);

    Redirect.typeName = 'Redirect';

    Redirect.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Redirect.prototype.execute = function (continuation) {
        var self = this;
        this.piping.busyIndicator.show();
        if (this.eventData.redirect.toLandingPage) {
            this.piping.dispatcher.dispatch("ApplicationRoot/GetLandingPageId")
            .then(this.redirectToActionWrapper.bind(this, continuation));
        } else if (this.eventData.redirect.toLoginPage) {
            this.piping.dispatcher.dispatch("ApplicationRoot/GetLoginPageId")
            .then(this.redirectToActionWrapper.bind(this, continuation));
        } else if (this.eventData.redirect.mockJumpOptions && this.eventData.redirect.mockJumpOptions.length > 1) {
            this.showOptionsPopup(continuation);
        } else if (this.eventData.redirect.type === 'Reload') {
            window.location.reload();
        } else if (this.isJumpToPrevious(this.eventData.redirect)) {
            var globals = this.piping.parameters.globals.getAll();
            var locals = this.getLocalsForNextPage(this.eventData.redirect);
            var previousActionId = this.piping.navigator.getPreviousId();
            this.handleNavigationTrailAndDo(continuation, function() {
                self.piping.navigator.goToPrevious(globals, locals);
            }, previousActionId, locals, globals);
        } else if (this.eventData.redirect.type === 'Event') {
			this.piping.eventing.publish(this.eventData.redirect.eventName, this.eventSource, null, continuation, this.getEventActionIdentifier());
        } else if (this.isJumpOutsideApplication(this.eventData.redirect)) {
            var targetUrl = this.getUrl(this.eventData.redirect);
            this.piping.url.openUrl(targetUrl, this.eventData.redirect.jumpToNewWindow);

            if (this.eventData.redirect.jumpToNewWindow) {
                continuation();
                this.piping.busyIndicator.hide();
            } else {
                if (this.linkWillNotCauseNavigationToAnotherPage(targetUrl))
                    continuation();
                this.piping.busyIndicator.forceHide();
            }
        } else if (this.eventData.redirect.navigationIdParameter) {
            this.handleNavigationJump(continuation, this.eventData.redirect);
        }
        else {
            this.redirectToActionWrapper(continuation);
        }
    };

    Redirect.prototype.isJumpToPrevious = function (redirect) {
        return redirect.type === 'Previous';
    };

    Redirect.prototype.isJumpOutsideApplication = function (redirect) {
        return redirect.url || redirect.applicationName || redirect.controllerAction;
    };

    Redirect.prototype.getUrl = function (redirect) {
        if (redirect.controllerAction) {
            var controllerActionUrl = lq.getTenantUrl('LicquidAction/' + redirect.controllerAction);
            return this.piping.url.prepare(controllerActionUrl, this.getParameters());
        }

        if (redirect.applicationName) {
            var applicationUrl = lq.getBaseUrl(lq.getTenantName() + '/' + redirect.applicationName + '/LicquidAction/Get/' + redirect.actionId);
            return this.piping.url.prepare(applicationUrl, this.getParameters());
        }

        if (redirect.url) {
            var url = redirect.isUrlFromParameter ? this.piping.parameters.getValue(redirect.url) : redirect.url;

            if (url.indexOf('@') !== -1) {
                if (this.isEmailLink(url))
                    return url;
                return 'mailto:' + url;
            }

            var locals = this.getLocalsForNextPage(this.eventData.redirect);
            if (url.indexOf('tel:') === -1)
                url = util.convertRelativeHyperlinkToHostName(url);

            if (_.keys(locals).length > 0)
                url = url + '?parameters=' + encodeURIComponent(JSON.stringify(locals));

            return url;
        }

        return undefined;
    };

    Redirect.prototype.getParameters = function () {
        var params = {};

        var globals = this.piping.parameters.globals.getAll();
        if (_.keys(globals).length > 0)
            params['globals'] = JSON.stringify(globals);

        var locals = this.getLocalsForNextPage(this.eventData.redirect);
        if (_.keys(locals).length > 0)
            params['parameters'] = JSON.stringify(locals);

        return params;
    };

    Redirect.prototype.linkWillNotCauseNavigationToAnotherPage = function (targetUrl) {
        targetUrl = targetUrl.toLowerCase();

        return targetUrl.indexOf('mailto:') === 0
            || targetUrl.indexOf('skype:') === 0
            || targetUrl.indexOf('tel:') === 0
            || targetUrl.indexOf('webcal:') === 0;
    };

    Redirect.prototype.getActionId = function (redirect) {
        if (redirect.actionId)
            return redirect.actionId;

        return this.piping.parameters.getValue(redirect.actionIdParameter);
    };

    Redirect.prototype.getNavigationId = function (redirect) {
        return this.piping.parameters.getValue(redirect.navigationIdParameter);
    };

    var globalParamExceptions = [
        "MockSessionId",
        "EntityId",
        "RootEntity",
        "PageId",
        "ExecutionId",
        "ProcessId",
    ];

    Redirect.prototype.handleNavigationJump = function (continuation, redirect) {
        var self = this;

        var navigationId = this.getNavigationId(redirect);
        self.piping.dispatcher.dispatch("LicquidAction/GetNavigation", {
                id: navigationId
            })
            .then(function (nav) {
                if (nav.toLocalParameters) nav.toLocalParameters = JSON.parse(nav.toLocalParameters);
                if (nav.toGlobalParameters) nav.toGlobalParameters = JSON.parse(nav.toGlobalParameters);

                var usedLocals = {};
                var usedGlobals = {};
                if (redirect.navigationIdParameterObjectParameter) {
                    usedLocals = self.piping.parameters.getValue(redirect.navigationIdParameterObjectParameter) || {};
                } else {
                    usedLocals = nav.toLocalParameters;
                }

                usedGlobals = nav.toGlobalParameters ?? {};
                var allGlobals = self.piping.parameters.globals.getAll();
                _.each(Object.keys(allGlobals), function (globalKey) {
                    if (!globalParamExceptions.includes(globalKey))
                        usedGlobals[globalKey] = allGlobals[globalKey];
                });

                self.redirectToActionWrapper(continuation, nav.toActionId, usedLocals, usedGlobals, true);
            });
    };

    Redirect.prototype.isEmailLink = function (targetUrl) {
        return targetUrl.toLowerCase().indexOf('mailto:') === 0;
    };

    Redirect.prototype.getLocalsForNextPage = function (redirect) {
        if (!redirect.jumpParameters)
            return {};

        var localsForNextPage = {};

        for (var i = 0; i < redirect.jumpParameters.length; i++) {
            var jumpParameter = redirect.jumpParameters[i];
            localsForNextPage[jumpParameter] = this.piping.parameters.locals.getValue(jumpParameter);
        }

        return localsForNextPage;
    };

    Redirect.prototype.redirectToActionWrapper = function (continuation, actionId, withLocals, withGlobals, skipNavigationTrail) {
        var self = this;
        var destinationActionId = actionId || this.getActionId(this.eventData.redirect);
        var locals = this.getLocalsForNextPage(this.eventData.redirect);
        var globals = this.piping.parameters.globals.getAll();

        if (withLocals !== undefined) locals = withLocals || {};
        if (withGlobals !== undefined) globals = withGlobals || {};

        this.handleNavigationTrailAndDo(continuation, function() {
            self.redirectToAction(destinationActionId, locals, globals);
        }, destinationActionId, locals, globals, skipNavigationTrail);
    };


    Redirect.prototype.handleNavigationTrailAndDo = function (continuation, callback, destinationActionId, locals, globals, skipNavigationTrail) {
        var self = this;
        if (
            !skipNavigationTrail &&
            this.getParentCommand() !== "LogoffCommand" && // If the parent command were a 'LogoffCommand' updating the navigation trail would cause a 401 response
            this.rootDrop.options.cqConfiguration &&
            this.rootDrop.options.cqConfiguration.navigationTrailEnabled &&
            _.some(["ExecutionId", "RootMorph", "ProcessId", "PageId"], function(name) { return self.piping.parameters.getValue(name); })
        ) {
            this.updateNavigationTrailAndDo(callback, destinationActionId, locals, globals);
        } else {
            callback();
        }

        continuation({ break: 'redirect' });
    };

    Redirect.prototype.updateNavigationTrailAndDo = function (callback, destinationActionId, locals, globals) {
        var self = this;
        this.piping.dispatcher
            .dispatch(
                'LicquidAction/UpdateNavigationTrail', {
                    url: this.getTargetUrl(destinationActionId, locals, globals),
                    globalParameters: this.piping.parameters.globals.getAll(),
                    rollbackEnabled: this.eventData.redirect.rollbackEnabled,
                    fromActionId: this.piping.actionId,
                    fromLocalParameters: this.piping.parameters.locals.getAll(),
                    toActionId: destinationActionId,
                    toLocalParameters: this.getLocalsForNextPage(this.eventData.redirect),
                    currentLayoutName: this.piping.parameters.getValue('CurrentLayoutName')
                })
            .done(function () {
                callback();
            }, $.noop);
    };

    Redirect.prototype.getParentCommand = function () {
        if (this.eventArg && this.eventArg.parentCommand)
            return this.eventArg.parentCommand;

        return undefined;
    };

    Redirect.prototype.redirectToAction = function (destinationActionId, locals, globals) {
        this.piping.navigator.openAction(
            destinationActionId,
            globals,
            locals,
            this.eventData.redirect.jumpToNewWindow);
        if (this.eventData.redirect.jumpToNewWindow)
            this.piping.busyIndicator.forceHide();
    };

    // this should be temporary (until Licquid natively supports going back in navigation trail)
    Redirect.prototype.getTargetUrl = function (destinationActionId, locals, globals) {
        var parameters = {};

        if (_.keys(globals).length)
            parameters.globals = JSON.stringify(globals);

        if (_.keys(locals).length)
            parameters.parameters = JSON.stringify(locals);

        return this.piping.url.prepare(lq.getFullUrl(lq.getTenantUrl('LicquidAction/Get/' + destinationActionId)), parameters);
    };

    Redirect.prototype.showOptionsPopup = function (continuation) {
        var self = this;
		var messageId = Math.floor(Math.random() * 1E10);

        var responseListener = function (message) {
			if (message.data  && message.data.id === messageId) {
                window.removeEventListener('message', responseListener);
                if (message.data.type === "JUMP_OPTIONS_POPUP_NAVIGATED") {
                    if (message.data.actionId) {
                        self.redirectToActionWrapper(continuation, message.data.actionId);
                    } else if (message.data.cqProcessId) {
                        if (message.data.cqProcessId) self.piping.parameters.locals.setValue("ProcessId", message.data.cqProcessId);
                        self.piping.eventing.publish("MP Start Process", self.eventSource, message.data.cqProcessId, function () { continuation({ break: 'redirect' }); }, self.getEventActionIdentifier());
                    }
                }
                else if (message.data.type === "POPUP_CLOSED")
                    continuation();
            }
		};

		window.addEventListener('message', responseListener);
        validatorGateway.publishEvent({
            type: "SHOW_JUMP_OPTIONS_POPUP",
            id: messageId,
            options: this.eventData.redirect.mockJumpOptions
        });
    };

    return Redirect;
});
